import axios from 'axios'

export default {
    getUuidFromRemote: async function () {
        try {
            let res = await axios.get(`${window.$apiurl}/newuuid`)
            return res.data.status === 'ok' ? res.data.data : null              
        } catch(e) {
            window.$showError(e)
        }
    },

    sendRequestToServer: async function (uuid, company) {
        try{
            let cloneOfCompany = Object.assign({}, company)
            delete cloneOfCompany.$titles
            delete cloneOfCompany.$types
            let res = await axios.post(`${window.$apiurl}/set`,{
                uuid: uuid,
                company: cloneOfCompany
            })
            return res.data.status === 'ok' && res.data.data === 'accepted' ? true : false
        } catch(e) {
            window.$showError(e)
        }
    }
}